module.exports = __webpack_public_path__ + "static/img/logo_white1.7c46c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_white1.png
// module id = Qes6
// module chunks = 44